/* eslint-disable */
import {
  UPDATE_EVENTS,
  SET_SEASON,
  SET_EVENT_TYPE,
  SET_MONTH,
  SET_TOURNAMENT,
  LOAD_MORE_EVENTS,
  SET_LOADING,
  RELOAD_EVENTS,
} from './filters_constants';

const initialState = {
  loading: true,
  eventsList: [],
  filteredEvents: [],
  selectedSeason: null,
  selectedType: { value: 'All' },
  selectedMonth: { value: 'All' },
  selectedTournament: 0,
  pagination: {
    currentPage: 1,
    perPage: 10,
    totalCount: 0,
    totalPages: 0,
    hasMore: false,
  },
};

export default function (state = initialState, action) {
  switch (action.type) {
    case UPDATE_EVENTS:
      const events = action.payload.events || action.payload;
      const pagination = action.payload.pagination || state.pagination;
      return {
        ...state,
        eventsList: events,
        filteredEvents: events, // No client-side filtering, events come pre-filtered from server
        pagination: pagination,
        loading: false,
      };
    case SET_SEASON:
      return {
        ...state,
        selectedSeason: action.season,
        // Don't filter here - will be handled by reloadEventsWithFilters action
      };
    case SET_EVENT_TYPE:
      return {
        ...state,
        selectedType: action.payload,
        // Don't filter here - will be handled by reloadEventsWithFilters action
      };
    case SET_MONTH:
      return {
        ...state,
        selectedMonth: action.payload,
        // Don't filter here - will be handled by reloadEventsWithFilters action
      };
    case SET_TOURNAMENT:
      return {
        ...state,
        selectedTournament: action.tournament,
        // Don't filter here - handled by reloadEventsWithFilters
      };
    case LOAD_MORE_EVENTS:
      return {
        ...state,
        eventsList: [...state.eventsList, ...action.payload.events],
        filteredEvents: [...state.filteredEvents, ...action.payload.events], // Append to filtered events
        pagination: action.payload.pagination,
        loading: false,
      };
    case RELOAD_EVENTS:
      return {
        ...state,
        eventsList: action.payload.events,
        filteredEvents: action.payload.events, // Replace with new filtered results
        pagination: action.payload.pagination,
        loading: false,
      };
    case SET_LOADING:
      return {
        ...state,
        loading: action.loading,
      };
    default:
      return state;
  }
}
